module.exports = "/img/icon-featured.svg?a53d8aad4cdd2d6ecdf8346985faa9ea";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/icon-featured.svg
// module id = /dm3
// module chunks = 46